// removed by extract-text-webpack-plugin
module.exports = {"Image":"src-components-Greeting-__MainGreeting-module___Image","Span":"src-components-Greeting-__MainGreeting-module___Span","Span2":"src-components-Greeting-__MainGreeting-module___Span2","A":"src-components-Greeting-__MainGreeting-module___A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Greeting/MainGreeting.module.css
// module id = 1214
// module chunks = 1